import script from "./VanSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./VanSelect.vue?vue&type=script&setup=true&lang=js"

import "./VanSelect.vue?vue&type=style&index=0&id=43f36b8b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43f36b8b"]])

export default __exports__